import React from 'react';
import { HomeOutlined } from '@ant-design/icons';
import BreadcrumbComponent from '../component/BreadcrumbComponent';

const defaultBreadcrumbPath = [{ name: <HomeOutlined />, link: '/dashboard' }];

export const DashboardBreadcrumb = {
	title: 'Dashboard Management',
	path: [...defaultBreadcrumbPath, { name: 'Dashboard Management' }],
};

export const UsersBreadcrumb = {
	title: 'User Management',
	path: [...defaultBreadcrumbPath, { name: 'User Management' }],
};

export const BookingInvoiceBreadcrumb = {
	title: 'Booking Invoice',
	path: [...defaultBreadcrumbPath, { name: 'Booking Invoice' }],
}

export const PaymentBreadcrumb = {
	title: 'Payments',
	path: [...defaultBreadcrumbPath, { name: 'Payments' }],
};

export const CustomerBreadcrumb = {
	title: 'Customers',
	path: [...defaultBreadcrumbPath, { name: 'Customers' }],
}

export const EnquiryBreadcrumb = {
	title: 'Enquiry',
	path: [...defaultBreadcrumbPath, { name: 'Enquiry' }],
}

export const AdminSettingsBreadcrumb = {
	title: 'Admin Settings Management',
	path: [...defaultBreadcrumbPath, { name: 'Admin Settings Management' }],
};

export const MerchantBreadcrumb = {
	title: 'Merchant Management',
	path: [...defaultBreadcrumbPath, { name: 'Merchant Management' }],
};

export const TempleBreadrumbs = {
	title: 'Temple Management',
	path: [...defaultBreadcrumbPath, { name: 'Temple Management' }],
};

export const TempleBulkImportBreadcrumb = {
	title: 'Temple Bulk Import',
	path: [...defaultBreadcrumbPath, { name: 'Temple Bulk Import' }],
};

export const AccommodationBulkImportBreadcrumb = {
	title: 'Accommodation Bulk Import',
	path: [...defaultBreadcrumbPath, { name: 'Accommodation Bulk Import' }],
};
export const AccommodationBreadrumbs = {
	title: 'Accommodation Management',
	path: [...defaultBreadcrumbPath, { name: 'Accommodation Management' }],
};
export const RegionBreadrumbs = {
	title: 'Region',
	path: [...defaultBreadcrumbPath, { name: 'Region' }],
};
export const PublicSettingsBreadCrumbs = {
	title: 'Public Settings Management',
	path: [...defaultBreadcrumbPath, { name: 'Public Settings Management' }],
};
export const MainBreadcumrs = ({ currentPath }) => {
	switch (currentPath) {
		case '/dashboard':
			return <BreadcrumbComponent items={DashboardBreadcrumb.path} />;
		case '/users':
			return <BreadcrumbComponent items={UsersBreadcrumb.path} />;
		case '/bookinginvoice':
			return <BreadcrumbComponent items={BookingInvoiceBreadcrumb.path} />;
		case '/payments':
			return <BreadcrumbComponent items={PaymentBreadcrumb.path} />;
		case '/customers':
			return <BreadcrumbComponent items={CustomerBreadcrumb.path} />;
		case '/enquiry':
			return <BreadcrumbComponent items={EnquiryBreadcrumb.path} />;
		case '/admin-settings':
			return <BreadcrumbComponent items={AdminSettingsBreadcrumb.path} />;
		case '/merchant':
			return <BreadcrumbComponent items={MerchantBreadcrumb.path} />;
		case '/temples':
			return <BreadcrumbComponent items={TempleBreadrumbs.path} />;
		case '/bulk-import/temple':
			return (
				<BreadcrumbComponent items={TempleBulkImportBreadcrumb.path} />
			);
		case '/bulk-import/accommodation':
			return (
				<BreadcrumbComponent
					items={AccommodationBulkImportBreadcrumb.path}
				/>
			);
		case '/accommodation':
			return <BreadcrumbComponent items={AccommodationBreadrumbs.path} />;
		case '/region':
			return <BreadcrumbComponent items={RegionBreadrumbs.path} />;
		case '/public-settings':
			return (
				<BreadcrumbComponent items={PublicSettingsBreadCrumbs.path} />
			);
		default:
			return <BreadcrumbComponent items={[...defaultBreadcrumbPath]} />;
	}
};
